module.exports = __webpack_public_path__ + "static/media/empty-line-graph.e5a3871b.png";